import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import { Modal } from 'components';
import style from './index.module.css';
import { IconLoginSuccessByQRCode } from '@/assets/login';

const { CenterModal } = Modal;

export const APPLoginSuccessModal = ({ close }: { close: () => void }) => {
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(() => {
      close();
    }, 1000);
    return () => {
      timer && clearTimeout(timer);
    };
  }, [close]);

  return (
    <CenterModal onRequestClose={close} shouldCloseOnOverlayClick={true} shouldCloseOnEsc={true}>
      <div className={style.modal}>
        <IconLoginSuccessByQRCode className={style.successIcon} />
        <div className={style.successText}>{t('AppLoginSuccessModal.qszv0x')}</div>
        <div className={style.continueText}>{t('AppLoginSuccessModal.16d2a4o')}</div>
      </div>
    </CenterModal>
  );
};

export default React.memo(APPLoginSuccessModal);
